module.exports = __webpack_public_path__ + "img/home.f7a110f1.svg";